import { useEffect } from "react";

/**
 * While active, the browser asks before the page goes away: tab close,
 * reload, or a back navigation that leaves the app. In-app route changes
 * don't unload the page, so they never trigger it.
 */
export function useBeforeUnloadWarning(active: boolean): void {
  useEffect(() => {
    if (!active) return undefined;
    const warn = (event: BeforeUnloadEvent) => {
      event.preventDefault();
      event.returnValue = "";
    };
    window.addEventListener("beforeunload", warn);
    return () => window.removeEventListener("beforeunload", warn);
  }, [active]);
}
